import React, { useCallback } from 'react';
import { Tooltip } from 'styleguide';

import { ValueBox, ValueGroup } from '@candu-ai/craft/ui';
import { ListVariants } from 'craft/constants';
import { Section, Toggle } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import { ListBullet, ListNumbered } from 'craft/icons';
import { useEnum } from 'craft/state';

interface Props {
  nodeIds: string[];
}

export const ListSettings = ({ nodeIds }: Props) => {
  const list = useEnum('Lists');
  const {
    custom,
    actions: { setCustom },
  } = useMultiNodes(nodeIds, (node) => ({
    custom: node?.data.custom.custom as Record<string, any>,
  }));

  const { variant } = custom || {};

  const changeVariant = useCallback((inputVariant: ListVariants) => {
    setCustom({
      custom: {
        variant: inputVariant || ListVariants.UL,
      },
    });
  }, []);

  return (
    <Section name="List Settings">
      <ValueGroup>
        <ValueBox label="List Type">
          {list?.values.map(({ value, name }) => (
            <Tooltip key={value} content={name} position="top" showDelay={500}>
              <Toggle
                data-cy={`list-type-${value}`}
                onClick={() => changeVariant(value as ListVariants)}
                isActive={variant === value}
                icon={value === ListVariants.OL ? ListNumbered : ListBullet}
              />
            </Tooltip>
          ))}
        </ValueBox>
      </ValueGroup>
    </Section>
  );
};
